import React, { useState, useEffect } from "react";
import {
    Button,
    FormControl,
    MenuItem,
    Select,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { ShowGlobalErrorAlert } from "../../actions";
import SuccessAlert from "../mui/SuccessAlert";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import lens from "../../images/lens-logo.svg";
import tekvisionlogo from "../../images/tekvisionlogo.svg";
import { fetchCognitoConfig } from "../../api/config.service";

const useStyles = makeStyles(() => ({
    page: {
        opacity: 1,
    },
}));

const Login = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [unauthorizedError, setUnauthorizedError] = useState(false);
    const [language, setLanguage] = useState("en");
    const globalErrorAlert = useSelector(state => state.reportReducer.globalErrorAlert);
    const { t } = useTranslation();
    const version = process.env.REACT_APP_RELEASE_VERSION;

    const handleLanguageChange = (event) => {
        i18n.changeLanguage(event.target.value);
        setLanguage(event.target.value);
    };

    const handleCognitoLogin = async () => {
        try {
            const cognitoConfig = await fetchCognitoConfig();

            const redirectUri = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`;
            const cognitoUrl = `${cognitoConfig.domain}/oauth2/authorize?client_id=${cognitoConfig.clientId}&response_type=${cognitoConfig.responseType}&scope=${encodeURIComponent(cognitoConfig.scope)}&redirect_uri=${encodeURIComponent(redirectUri)}`;

            document.location.href = cognitoUrl;
        } catch (error) {
            console.error('Cognito login failed:', error);
            setUnauthorizedError(true);
        }
    }

    useEffect(() => {
        document.body.style.backgroundColor = "#FFFFFF";
    }, []);

    useEffect(() => {
        if (globalErrorAlert) {
            setShowErrorAlert(true);

            setTimeout(() => {
                ShowGlobalErrorAlert(null)(dispatch);
            }, 6000);
        } else {
            setShowErrorAlert(false);
        }

    }, [globalErrorAlert]);

    // Check for unauthorized error in query params
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('error') === 'unauthorized') {
            setUnauthorizedError(true);
            // Clean up the URL
            window.history.replaceState({}, document.title, '/');
        }
    }, []);

    return (
        <div className={classes.page}>
            <div className="login-container">
                <div className="login-language">
                    <FormControl>
                        <Select
                            value={language}
                            onChange={handleLanguageChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            size="small"
                        >
                            <MenuItem value={"en"}>English</MenuItem>
                            <MenuItem value={"fr"}>French</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="login-area">
                    <div className="login-left">
                        <img src={tekvisionlogo} alt="TekVision" />
                        {version && <div className="version">v{version}</div>}
                    </div>
                    <div className="login-right">
                        <div className="center-logo">
                            <img src={lens} alt="Lens" />
                            <div className="login-header-title">Action Center</div>

                            <div className="db mt-24">
                                <Button
                                    variant={'contained'}
                                    color={"primary"}
                                    className="btn-primary"
                                    onClick={handleCognitoLogin}
                                    style={{ width: '245px' }}
                                >
                                    {t('Login with Cognito')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showErrorAlert && (
                <SuccessAlert width="80%"
                    setOpenAlert={setShowErrorAlert}
                    top="10px"
                    openAlert={showErrorAlert}
                    statement={globalErrorAlert || ''} fail="error" />
            )}

            {unauthorizedError && (
                <SuccessAlert
                    width="80%"
                    setOpenAlert={setUnauthorizedError}
                    top="10px"
                    openAlert={unauthorizedError}
                    statement={["You are not authorized to access this resource. Please reach out to your system admin."]}
                    fail="error" />
            )}
        </div>
    );
};

export default Login;
